<template>
	<div class="model1">
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="infoTitle">
				{{ detailsData.regionName }}

				<img
					style="vertical-align: middle;margin-left: 5px;"
					src="../../assets/actionPlan/planTtile.jpg"
					alt=""
				/>
			</div>
			<!-- 列表部分 -->
			<div style="display:flex;justify-content: space-between;">
				<div
					v-for="(item, index) in baseData"
					:key="index"
					class="yBoxs"
				>
					<div class="yTilte">
						{{ item.name }}
					</div>
					<div class="yYear">
						{{ item.year }}
					</div>
					<div class="yValue">
						<div class="Num">
							{{ item.value }}
						</div>
						<div class="yUnit">
							{{ item.unit }}
						</div>
					</div>
				</div>
			</div>
			<!-- 文字框1 -->
			<div style="margin-bottom: 50px;">
				<div class="planListTitle">
					<img
						style="vertical-align: -9%;"
						src="../../assets/main/title_icon.jpg"
						alt=""
					/>
					主要目标
				</div>
				<div class="planLists" style="margin-bottom: 30px;">
					<img
						class="planListImg"
						src="../../assets/actionPlan/planLeft1.png"
						alt=""
					/>
					<el-scrollbar class="detailsBlocksContent plans">
						<p>{{ detailsData.plan1 }}</p>
					</el-scrollbar>
					<div class="rowChunk details4_1">
						<acrossBar
							echartsId="acrossBar_echarts_1"
							:echartsData="acrossBarDatas[0]"
						/>
					</div>
				</div>
				<div class="planLists">
					<img
						class="planListImg"
						src="../../assets/actionPlan/planLeft2.png"
						alt=""
					/>
					<el-scrollbar class="detailsBlocksContent plans">
						<p>{{ detailsData.plan2 }}</p>
					</el-scrollbar>
					<div class="rowChunk details4_2">
						<acrossBar
							echartsId="acrossBar_echarts_2"
							:echartsData="acrossBarDatas[1]"
						/>
					</div>
				</div>
			</div>
			<!-- 文字框2 -->
			<div>
				<div
					class="detailsBlocks"
					v-for="(item, index) in baseDatadetails"
					:key="index"
				>
					<div class="detailsBlocksTitle">
						<img
							src="../../assets/actionPlan/titlebackground_details.png"
							alt=""
						/>
						<div class="title_block">{{ item.title }}</div>
					</div>
					<div>
						<el-scrollbar class="detailsBlocksContent">
							<p>{{ item.content }}</p>
						</el-scrollbar>
					</div>
				</div>
			</div>
			<div>
				<a
					class="sourceLink"
					:href="
						detailsData.source
							? detailsData.source.split('--')[1]
							: ''
					"
					target="_blank"
				>
					来源：{{
						detailsData.source
							? detailsData.source.split('--')[0]
							: ''
					}}</a
				>
			</div>
			<!-- echarts -->
			<div>
				<div class="flexRow">
					<div class="flexColumn">
						<div class="planListTitle echartsTitle">
							<img
								style="vertical-align: -9%;"
								src="../../assets/main/title_icon.jpg"
								alt=""
							/>
							废气中主要污染物排放量
						</div>
						<stackedBar1
							:echartsData="stackedBar1Data"
							echartsId="stackedBar1Data_echarts_sf"
						></stackedBar1>
					</div>
					<div class="flexColumn">
						<div class="planListTitle echartsTitle">
							<img
								style="vertical-align: -9%;"
								src="../../assets/main/title_icon.jpg"
								alt=""
							/>
							废水中主要污染物排放量
						</div>
						<stackedBar2
							:echartsData="stackedBar2Data"
							echartsId="stackedBar2Data_echarts_sf"
						></stackedBar2>
					</div>
				</div>
				<div class="flexRow">
					<div class="flexColumn">
						<div class="planListTitle echartsTitle">
							<img
								style="vertical-align: -9%;"
								src="../../assets/main/title_icon.jpg"
								alt=""
							/>
							造林面积
						</div>
						<stackedBarAndLine
							:echartsData="stackedBarAndLineData"
							echartsId="stackedBarAndLineData_echarts_sf"
						></stackedBarAndLine>
					</div>
					<div class="flexColumn">
						<div class="planListTitle echartsTitle">
							<img
								style="vertical-align: -9%;"
								src="../../assets/main/title_icon.jpg"
								alt=""
							/>
							太阳能发电装机容量
						</div>
						<fineBar
							:echartsData="fineBarData"
							echartsId="fineBarData_echarts_sf"
						></fineBar>
					</div>
				</div>
			</div>
			<div class="planListTitle policy">
				<img
					style="vertical-align: -10%;"
					src="../../assets/actionPlan/policyTitle.png"
					alt=""
				/>
				<a
					href="#/column?id=13&name=政策规划&uid=A6020102&showType=1-1"
					class="city"
					>地方政策</a
				>
				<a
					class="article_l_more"
					:href="
						`#/column?id=13&name=政策规划&uid=A6020102&showType=1-1&areaType=${
							detailsData.position
						}&areaName=${
							detailsData.regionName
								? detailsData.regionName.replace(
										/(自治区|省|市)/g,
										''
								  )
								: detailsData.regionName
						}`
					"
					target="_blank"
					>更多<img src="../../assets/main/more.png" alt=""
				/></a>
			</div>
			<ul class="m1_info_ul" style="margin-top:20px;">
				<li v-for="(item, index) in dataList" :key="index">
					<a
						class="m1_info_li_r"
						:href="
							'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
								item.docid +
								'&leafid=' +
								item.leafid
						"
						target="_blank"
					>
						<img
							src="../../assets/actionPlan/policyDetail.png"
							alt=""
						/>
						<h6
							v-html="
								item.title.replace(
									/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
									''
								)
							"
						></h6>
						<!-- <span
							v-html="
								item.summary.replace(
									/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
									''
								)
							"
						></span> -->
					</a>
				</li>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<!-- <div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					background
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div> -->
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';
import acrossBar from './components/acrossBar';
import stackedBar1 from './components/stackedBar1';
import stackedBar2 from './components/stackedBar2';
import stackedBarAndLine from './components/stackedBarAndLine';
import fineBar from './components/fineBar';
export default {
	// 普通二级页(默认)
	props: ['currentChoose', 'currentModel'],
	components: {
		stackedBar1,
		stackedBar2,
		stackedBarAndLine,
		fineBar,
		acrossBar,
	},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 8, //每页条数
			dataList: [], //文章列表数据
			isValue1Updated: false,
			isValue2Updated: false,
			detailsData: {}, //详情全部数据
			baseData: [], //详情1数据
			baseDatadetails: [], //详情3数据
			stackedBar1Data: {},
			loading: false, //表格加载
			stackedBar2Data: {},
			stackedBarAndLineData: {},
			fineBarData: {},
			acrossBarDatas: [],
		};
	},
	watch: {
		currentChoose: {
			handler(val) {
				// console.log(val);
				this.isValue1Updated = true;
				this.currentPage = 1;
				//过滤掉全国
				if (val != '1') {
					this.fetchDataList(val); //获取文章列表
				}
			},
			immediate: true, //初始化时候就执行
		},
		currentModel: {
			handler(val) {
				// console.log(val);
				this.isValue2Updated = true;
				this.currentPage = 1;
				//过滤掉全国
				if (val.uid != '1') {
					this.fetchDataList(val.uid); //获取文章列表
				}
			},
			// immediate: true, //初始化时候就执行
		},
	},
	computed: {},
	created() {},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background','#4EAC41');
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			// 分页样式
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background-color', 'rgb(78, 172, 65)');
			// $('.el-pagination.is-background .el-pager li:not(.disabled).active').css('background-color', 'rgb(78, 172, 65)');
		}, 200);
		// //console.log(this.currentModel, '123213213213213');
		// this.fetchDataList(this.currentChoose);
	},
	methods: {
		//获取数据列表
		fetchDataList(_uid, currentflag) {
			// this.$nextTick(() => {
			if (currentflag || (this.isValue1Updated && this.isValue2Updated)) {
				//1-2-3块详情数据

				api.getBasicInfos(_uid).then((res) => {
					this.baseData = [];
					this.baseDatadetails = [];
					if (res.data) {
						this.detailsData = res.data;
						this.baseData.push({
							name: 'GDP',
							year: res.data.gdp.split('/')[2],
							value: res.data.gdp.split('/')[0],
							unit: res.data.gdp.split('/')[1],
						});
						this.baseData.push({
							name: '第三产业占GDP比重  ',
							year: res.data.thirdIndustryRatio.split('/')[2],
							value: res.data.thirdIndustryRatio.split('/')[0],
							unit: res.data.thirdIndustryRatio.split('/')[1],
						});
						this.baseData.push({
							name: '常住人口',
							year: res.data.population.split('/')[2],
							value: res.data.population.split('/')[0],
							unit: res.data.population.split('/')[1],
						});
						this.baseData.push({
							name: '用电量',
							year: res.data.electricityConsum.split('/')[2],
							value: res.data.electricityConsum.split('/')[0],
							unit: res.data.electricityConsum.split('/')[1],
						});
						this.baseData.push({
							name: '城市污水排放量',
							year: res.data.urbanSewageAmount.split('/')[2],
							value: res.data.urbanSewageAmount.split('/')[0],
							unit: res.data.urbanSewageAmount.split('/')[1],
						});
						for (let index = 1; index <= 6; index++) {
							this.baseDatadetails.push({
								title: res.data['description' + index].split(
									'--'
								)[0],
								content: res.data['description' + index].split(
									'--'
								)[1],
							});
						}

						//数据需要格式化处理
						// this.dataList = res.data.rows;
						// this.total = res.data.total;
					}
				});
				//echarts图数据
				api.getGraphicData({ type: 1, uid: _uid }).then((res) => {
					if (res.data) {
						//console.log(res, 'echartsssssssssss');
						this.stackedBar1Data = res.data;
						// this.total = res.data.total;
					}
				});
				//echarts图数据
				api.getGraphicData({ type: 2, uid: _uid }).then((res) => {
					if (res.data) {
						//console.log(res, 'echartsssssssssss');
						this.stackedBar2Data = res.data;
					}
				});
				//echarts图数据
				api.getGraphicData({ type: 3, uid: _uid }).then((res) => {
					if (res.data) {
						//console.log(res, 'echartsssssssssss');
						this.fineBarData = res.data;
					}
				});
				//echarts图数据
				api.getGraphicData({ type: 4, uid: _uid }).then((res) => {
					if (res.data) {
						//console.log(res, 'echartsssssssssss');
						this.stackedBarAndLineData = res.data;
					}
				});
				let params = {
					uid: 'A6020102',
					pagesize: this.pagesize,
					curpage: this.currentPage,
					dateType: this.dataType,
					startDate: this.startDate,
					endDate: this.endDate,
					keyword: this.currentModel.title_name
						? this.currentModel.title_name.replace(
								/(自治区|省|市)/g,
								''
						  )
						: this.currentModel.title_name,
				};
				this.loading = true; //表格加载
				//文章数据
				api.getarticleList(params).then((res) => {
					if (res.data) {
						//console.log(res, 'list');
						this.dataList = res.data.rows;
						this.total = res.data.total;
						this.loading = false; //表格加载
					}
				});
				//两个柱图
				api.getSecondPracticeData(_uid).then((res) => {
					if (res.data) {
						//console.log(res, 'list');
						this.acrossBarDatas = res.data;
					}
				});
				this.isValue1Updated = false;
				this.isValue2Updated = false;
			}
			// });
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose, true);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 847px;
	height: 100%;
	overflow: hidden;
	padding: 14px 51px;
	background: #fff;
}

//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
	.infoTitle {
		font-family: Microsoft YaHei;
		padding: 24px 0 27px 0;
		font-weight: 600;
		font-size: 20px;
		color: #000000;
		line-height: 26px;
	}
	.yBoxs {
		background: url(../../assets/actionPlan/blockBack.png) no-repeat;
		height: 120px;
		width: 153px;
		padding: 16px;
		.yTilte {
			font-family: Microsoft YaHei;
			font-weight: bold;
			font-size: 13px;
			color: #222222;
			line-height: 18px;
			padding-bottom: 12px;
		}
		.yYear {
			font-family: Microsoft YaHei;
			font-weight: 400;
			font-size: 13px;
			color: #222222;
			line-height: 30px;
			padding-bottom: 5px;
		}
		.yValue {
			display: flex;
			align-items: baseline;
			.Num {
				font-family: Microsoft YaHei;
				font-weight: bold;
				font-size: 22px;
				color: #2a9a1f;
				line-height: 30px;
			}
			.yUnit {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 13px;
				color: #222222;
				line-height: 30px;
			}
		}
	}
	.planListTitle {
		font-family: Microsoft YaHei;
		font-weight: 600;
		font-size: 16px;
		color: #000000;
		line-height: 26px;
		padding-bottom: 10px;
		margin-bottom: 18px;
		border-bottom: 1px solid rgba(230, 230, 230, 0.9);
	}
	.echartsTitle {
		margin-top: 30px;
	}
	.policy {
		margin-top: 40px;
		display: flex;
		align-items: center;
		img {
			width: 17px;
			height: 17px;
			margin-right: 5px;
		}
		.city {
			// width: 100%;
			font-family: Microsoft YaHei;
			font-weight: 400;
			font-size: 16px;
			color: #000000;
		}
		// background: #084f00;
		.article_l_more {
			display: inline-block;
			margin-left: auto;
			cursor: pointer;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #1a1a1a;
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			// margin: 3px 0 0 8px;
			img {
				margin-left: 6px;
				margin-right: 3px;
				width: 9px;
				height: 9px;
			}
		}
	}
	.planLists {
		display: flex;
		align-items: center;
		.planListImg {
			height: 72px;
			width: 83px;
			min-width: 83px;
			margin-right: 21px;
		}
		.planListDiv {
			width: 731px;
			padding: 0 10px;
			font-family: Microsoft YaHei;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
			line-height: 26px;
		}
	}
	.detailsBlocks {
		position: relative;
		width: 400px;
		display: inline-block;
		margin-bottom: 23px;
		.detailsBlocksTitle {
			margin-bottom: 8px;
			width: 100%;

			.title_block {
				font-family: Microsoft YaHei;
				background: #fff;
				padding-right: 10px;
				top: 0;
				left: 26px;
				position: absolute;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				line-height: 26px;
			}
		}
	}
	.detailsBlocks:nth-child(2n) {
		margin-left: 40px;
	}
}
/deep/ .el-scrollbar__wrap {
	margin-right: -33px !important;
	padding-right: 15px;
	padding-bottom: 5px;
	overflow-x: auto;
	overflow-y: scroll !important;
}
.detailsBlocksContent {
	// width: 100%;
	max-width: 400px;
	height: 120px;
	// overflow-y: auto;
	padding: 15px;
	border: 1px solid rgba(229, 234, 229, 1);

	p {
		text-indent: 2em;
		font-family: Microsoft YaHei;
		font-weight: 400;
		font-size: 14px;
		color: #333333;

		line-height: 26px;
	}
}
.plans {
	// max-width: 350px;
	height: 165px;
	margin-right: 10px;
	border: 1px solid #d2d2d2;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	position: absolute;
	top: 50px;
	right: 0;
	height: 32px;
	line-height: 32px;
}
.m1_search_box span {
	width: 70px;
	height: 30px;
	background: #ffffff;
	border: 1px solid #e7ede5;
	display: inline-block;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #222222;
	text-align: center;
	line-height: 30px;
	position: relative;
	margin-right: 8px;
	cursor: pointer;
}
.m1_search_active {
	background: #edf7ec !important;
	border: 1px solid #4eac41 !important;
}
.m1_search_box span img {
	display: none;
}
.m1_search_active img {
	display: block !important;
	position: absolute;
	bottom: 0;
	right: 0;
}
.el-range-editor--small .el-range-input {
	border: 1px solid #ccc !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
}
.m1_info_ul li {
	width: 100%;
	height: 22px;
	// border-bottom: 1px solid #e7ede5;
	padding: 18px 0;
	cursor: pointer;
}

.m1_info_li_l {
	width: 126px;
	height: 100%;
	text-align: center;
	float: left;
	// border-right: 1px solid #f3f3f3;
}
.m1_info_li_l h6 {
	font-size: 22px;
	font-family: Arial;
	font-weight: 400;
	color: #1b1b1b;
	width: 100%;
	text-align: center;
}
.m1_info_li_l span {
	// width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.m1_info_li_r {
	// padding-left: 21px;
	// float: left;
	display: flex;
	align-items: center;
	width: 100%;
}
.m1_info_li_r h6 {
	font-size: 18px;
	width: 90%;
	font-family: Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #333333;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	// margin-bottom: 6px;
}
.m1_info_li_r h6:hover {
	color: #4eac41;
}
.m1_info_li_r img {
	width: 17px;
	height: 17px;
	margin-right: 5px;
}
.m1_info_li_r span {
	display: block;
	line-height: 24px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* 这里是超出几行省略 */
	overflow: hidden;
}
// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
.details4_1 {
	width: 365.5px;
	height: 195px;
	// margin-right: 19px;
	// margin-bottom: 16px;
	background: rgba(255, 255, 255, 0);
	border: 1px solid #d2d2d2;
}
.details4_2 {
	width: 365.5px;
	height: 195px;
	// margin-right: 19px;
	background: rgba(255, 255, 255, 0);
	border: 1px solid #d2d2d2;
}
#data-table {
	width: 100%;
	border-collapse: collapse;
	th,
	td {
		border: 1px solid #000;
		padding: 8px;
		text-align: center;
	}
	th {
		font-weight: bold;
		background: #f5f7f4;
	}
	th :nth-child(2n) {
		background: red;
	}
}
.sourceLink {
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1c1c1c;
	margin-bottom: 10px;
	display: block;
}
.sourceLink:hover {
	color: rgb(85, 190, 72);
}
.flexRow {
	display: flex;
	justify-content: space-between;
}
.flexColumn {
	display: flex;
	flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/view/actionPlan/modes.vue